import ClientJS from 'clientjs';
import logger from 'utils/logger';
import browserType from 'assets/data/self-use/browserTypes';

const getVideoFullScreenDetails = () => {
  const clientJs = new ClientJS();
  const browserNameRaw = clientJs.getBrowser();
  // Guard against non-string values from clientjs (e.g., null/undefined/object)
  const name = (typeof browserNameRaw === 'string' ? browserNameRaw : '').toLowerCase();
  let requestFullScreen = null;
  let exitFullScreen = null;
  let fullscreenchangeEventName = null;

  // Prefer feature detection over browser-name sniffing. This avoids returning
  // a null event name when clientjs returns an unexpected value.
  try {
    const doc = document;
    const isfullScreenSupported = !!(
      doc.fullscreenEnabled ||
      doc.webkitFullscreenEnabled ||
      doc.mozFullScreenEnabled ||
      doc.msFullscreenEnabled
    );

    if (doc.fullscreenEnabled && doc.documentElement?.requestFullscreen) {
      requestFullScreen = (ref) => ref.requestFullscreen();
      exitFullScreen = () => doc.exitFullscreen?.();
      fullscreenchangeEventName = 'fullscreenchange';
    } else if (
      doc.webkitFullscreenEnabled &&
      doc.documentElement?.webkitRequestFullscreen
    ) {
      requestFullScreen = (ref) => ref.webkitRequestFullscreen();
      exitFullScreen = () => doc.webkitExitFullscreen?.();
      fullscreenchangeEventName = 'webkitfullscreenchange';
    } else if (
      doc.mozFullScreenEnabled &&
      doc.documentElement?.mozRequestFullScreen
    ) {
      requestFullScreen = (ref) => ref.mozRequestFullScreen();
      exitFullScreen = () => doc.mozCancelFullScreen?.();
      fullscreenchangeEventName = 'mozfullscreenchange';
    } else if (
      doc.msFullscreenEnabled &&
      doc.documentElement?.msRequestFullscreen
    ) {
      requestFullScreen = (ref) => ref.msRequestFullscreen();
      exitFullScreen = () => doc.msExitFullscreen?.();
      fullscreenchangeEventName = 'MSFullscreenChange';
    }

    if (isfullScreenSupported && !fullscreenchangeEventName) {
      // Fallback: never return null when fullscreen is supported.
      fullscreenchangeEventName = 'fullscreenchange';
    }

    if (!isfullScreenSupported) {
      logger.warn(
        'browser does not support full screen api',
        'videoscreen.utils.getFullScreenApi',
        { browsername: name }
      );
    }

    return {
      requestFullScreen,
      exitFullScreen,
      isfullScreenSupported,
      browserName: name,
      fullscreenchangeEventName
    };
  } catch {
    logger.error(
      'Unable to fetch fullscreen api',
      'videoscreen.utils.getFullScreenApi'
    );
  }

  const isfullScreenSupported = false;
  return {
    requestFullScreen,
    exitFullScreen,
    isfullScreenSupported,
    browserName: name,
    fullscreenchangeEventName
  };
};

export default getVideoFullScreenDetails;
